<div class="progress-bar-container">
  <div class="progress-bar" [ngClass]="disabled() ? 'disabled' : ''" [style.width]="percent() + '%'"></div>
</div>
